
const typeMap = {
  styles: 'css',
  scripts: 'js'
}

export default typeMap